module.exports = "/_next/static/images/projectEngineering2-ef67802d93967b10b4ea9c275fa5aa0c.webp";